import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Select } from '@/components/ui/Input';

/**
 * Dropdown pemilih folder tujuan, dipakai di semua dialog yang butuh folder:
 * simpan ke cloud, pindahkan, impor dataset, dan kode terima transfer.
 * Menampilkan jalur lengkap ("/Riset/Kompetitor/") supaya folder senama di
 * cabang berbeda tetap bisa dibedakan.
 */
export const FolderPicker = ({ value, onChange, excludeId, ...props }) => {
  const { data } = useQuery({
    queryKey: ['storage-folders-all'],
    queryFn: () => api.get('/storage/folders/all'),
  });

  // `excludeId` menyaring folder itu sendiri beserta keturunannya - dipakai
  // dialog pindah supaya folder tidak bisa dipindahkan ke dalam dirinya.
  const semua = data?.data ?? [];
  const terlarang = excludeId ? semua.find((f) => f.id === excludeId)?.path : null;
  const folders = terlarang ? semua.filter((f) => !f.path.startsWith(terlarang)) : semua;

  return (
    <Select value={value} onChange={(e) => onChange(e.target.value)} {...props}>
      <option value="">Akar penyimpanan</option>
      {folders.map((f) => (
        <option key={f.id} value={f.id}>
          {f.path}
        </option>
      ))}
    </Select>
  );
};
